import { useTranslation } from 'react-i18next';
import { RIcon } from './RIcon';
import { RLogo } from './RLogo';

type Props = {
  variant: 'desktop' | 'mobile';
  canBack: boolean;
  onBack: () => void;
  onHelp: () => void;
  onHome?: () => void;
};

const WregTopbar = ({ variant, canBack, onBack, onHelp, onHome }: Props) => {
  const { t } = useTranslation();
  const desktop = variant === 'desktop';
  return (
    <div className={desktop ? 'reg-dt-topbar' : 'reg-appbar'}>
      <RLogo onClick={onHome} />
      <div className={desktop ? 'reg-dt-topbar-right' : 'reg-appbar-actions'}>
        {canBack && (
          <button type="button" className="dsb dsb-secondary dsb-s" onClick={onBack}>
            {t('wreg.nav.back')}
          </button>
        )}
        <button type="button" className="dsb dsb-secondary dsb-s dsb-ico" onClick={onHelp}>
          <span className="dsb-ic">
            <RIcon.faq />
          </span>
          {t('wreg.nav.help')}
        </button>
      </div>
    </div>
  );
};

export { WregTopbar };
